// The Backdrop is a simple component allowing a dark veil over the entire page. To place something on top of the
// overlay, give it a higher z-index than the .backdrop-container in the SCSS-file.
export default {
  name: 'backdrop-component',
  methods: {
    close () {
      if (this.$store.getters.backdropAllowClosing) {
        this.$store.dispatch('showBackdrop', false)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/backdrop/script.js